/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DeviceType, useDevice } from '@squiz/dxp-console-support';
import clsx from 'clsx';
import React from 'react';
import { GridItem } from './Grid.defs';
import { GridProps, gridDefaults } from './Grid.props';

/**
 * SDS Grid component.
 */
export const Grid = (props: GridProps): JSX.Element => {
  const { classes, columnCount, gap, items, ...rest } = {
    ...gridDefaults,
    ...props,
  };

  // Dynamic styles
  const columnStyle = {
    gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
    ...(gap !== undefined && { gap: `${gap}px` }),
  };

  // Device detection
  const deviceType = useDevice();
  const isMobile = deviceType === DeviceType.mobile;
  const isTabletSmall = deviceType === DeviceType.tabletSmall;

  const getGridItems = (): Array<JSX.Element> => {
    return items.map((item: GridItem, index: number): JSX.Element => {
      let itemCols = item.componentSize.colWidth;

      if (isMobile || isTabletSmall || itemCols > columnCount) {
        itemCols = columnCount;
      }

      // Dynamic styles
      const columnSpanStyle = {
        gridColumn: `span ${itemCols}`,
      };

      return (
        <div className="sds-grid-item" key={item.key} style={columnSpanStyle}>
          {item.component}
        </div>
      );
    });
  };

  const gridClass = clsx(`sds-grid`, classes);

  return (
    <div className={gridClass} style={columnStyle} {...rest}>
      {getGridItems()}
    </div>
  );
};
